import { render, staticRenderFns } from "./QueryPph.vue?vue&type=template&id=109a7d93"
import script from "./QueryPph.vue?vue&type=script&lang=js"
export * from "./QueryPph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports